import { render, staticRenderFns } from "./ProfilePlatformSettings.vue?vue&type=template&id=643ac384&scoped=true"
import script from "./ProfilePlatformSettings.vue?vue&type=script&lang=ts"
export * from "./ProfilePlatformSettings.vue?vue&type=script&lang=ts"
import style0 from "./ProfilePlatformSettings.vue?vue&type=style&index=0&id=643ac384&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643ac384",
  null
  
)

export default component.exports